<div class = "container">
    <div class="loading-overlay" *ngIf="loading">
        <mat-progress-spinner mode="indeterminate" diameter="40" strokeWidth="3"></mat-progress-spinner>
    </div>

    <form class = "card-form"  [formGroup]="motorForm" (ngSubmit)="submitForm()" autocomplete="off" novalidate>
        <div class="blue-top"></div>
        <div class="card-section top-section">
            <h1><b>{{pageHeading}}</b></h1>
            <h2>{{LanguagePack.detailsSubHeading}}</h2>

            <mat-form-field appearance="outline" class="form-select">
                <mat-label class="form-select-placeholder-unselected" >{{LanguagePack.fullNameLabel}}</mat-label>
                <input matInput formControlName="fullName" (blur)="logErrors()">
                <mat-error *ngIf="formErrors['fullName']">{{formErrors['fullName']}}</mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline" class="form-select">
                <mat-label class="form-select-placeholder-unselected" >{{LanguagePack.emailLabel}}</mat-label>
                <input matInput formControlName="email" (blur)="logErrors()">
                <mat-error *ngIf="formErrors['email']">{{formErrors['email']}}</mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline" class="form-select">
                <mat-label class="form-select-placeholder-unselected" >{{LanguagePack.phoneLabel}}</mat-label>
                <input matInput formControlName="phone" (blur)="logErrors()">
                <mat-error *ngIf="formErrors['phone']">{{formErrors['phone']}}</mat-error>
            </mat-form-field>

            <!-- <mat-form-field appearance="outline" class="form-select">
                <mat-label class="form-select-placeholder-unselected">
                    {{LanguagePack.idTypeLabel}}
                </mat-label>
                <mat-select formControlName="idType"  panelClass="form-select-popup" (blur)="logErrors()" (selectionChange)="updateID()">
                    <mat-option class="form-option" [value]="idTypePlaceHolders" *ngFor="let idTypePlaceHolders of LanguagePack.IdTypePlaceHolders">
                        {{idTypePlaceHolders}}
                    </mat-option>
                </mat-select>
                <mat-error *ngIf="formErrors['idType']">{{formErrors['idType']}}</mat-error>
            </mat-form-field> -->

            <mat-form-field appearance="outline" class="form-select">
                <mat-label class="form-select-placeholder-unselected" >{{idNumLabel}}</mat-label>
                <input matInput maxlength=9 formControlName="idNum" (blur)="logErrors()">
                <mat-error *ngIf="formErrors['idNum']">{{formErrors['idNum']}}</mat-error>
            </mat-form-field>

            <div class="row-div" style="padding-top: 50px; padding-bottom: 20px;">
                <button mat-stroked-button type="button" (click)="confirmCancel()">
                    <span class="button-text">{{LanguagePack.cancel}}</span>
                </button>
                <button mat-button type="submit" [disabled]="!motorForm.valid">
                    <span class="button-text">{{LanguagePack.saveContinue}}</span>
                </button>
            </div>
        </div>
    </form>
</div>
